import Home from './views/m/pages/Home/Home'
import Oder from './views/m/pages/Oder/Oder'
import Client from './views/m/pages/Client/Client'
import My from './views/m/pages/My/My'
import MyCouponsList from './views/m/pages/My/MyCouponsList'
import So from './views/m/pages/Special-offer/Special-offer'
import Hot from './views/m/pages/Hot/Hot'
import Brand from './views/m/pages/Brand/Brand'
import Payment from './views/m/pages/Payment/Payment'
import PayResult from './views/m/pages/Payment/Result'
import Sort from './views/m/pages/Sort/Sort'
import Data from './views/m/pages/Sort/Data'
import Transaction from './views/m/pages/Transaction/Transaction'
import Login from './views/m/pages/login/Login'
import Ppay from './views/m/pages/PendingPayment/PendingPayment'
import exp from './views/m/pages/Expresses/expresses'
import Tail from './views/m/pages/Expresses/tail'
import Register from './views/m/pages/Register/Register'
import ShopBind from './views/m/pages/shopBind/index'

export default [
    { path: '*', redirect: '/' },
    {
        path: '/m',
        name: 'm',
        component: () => import('./views/m.vue'),
        children: [
            {
                path: '/m',
                name: 'm.home',
                meta: {
                    title: '',
                    keepAlive: true,
                    navActive: 0
                },
                component: Home
            },
            {
                path: '/m/oder',
                name: 'm.oder',
                meta: {
                    title: '购物车',
                    auth: true,
                    keepAlive: true,
                    navActive: 3 // - 1
                },
                component: Oder
            },
            {
                path: '/m/client',
                name: 'm.client',
                meta: {
                    title: '客服',
                    navActive: 1
                },
                component: Client
            },
            {
                path: '/m/my',
                name: 'm.my',
                meta: {
                    title: '我的',
                    auth: true,
                    navActive: 4 // - 1
                },
                component: My
            },
            {
                path: '/m/myCouponsList',
                name: 'm.myCouponsList',
                meta: {
                    auth: true
                },
                component: MyCouponsList
            },
            {  /*限时特惠*/
                path: '/m/so',
                name: 'm.so',
                meta: {
                    keepAlive: true,
                    navActive: 0
                },
                component: So
            },
            {  /*火爆*/
                path: '/m/hot',
                name: 'm.hot',
                meta: {
                    keepAlive: true,
                    navActive: 0
                },
                component: Hot
            },
            {   /*品牌*/
                path: '/m/brand',
                name: 'm.brand',
                meta: {
                    keepAlive: true,
                    navActive: 0
                },
                component: Brand
            },
            {
                /*产品筛选*/
                path: '/m/sort',
                name: 'm.sort',
                meta: {
                    keepAlive: true,
                    navActive: 0
                },
                component: Sort
            },
            {
                /*品牌，分类筛选数据*/
                path: '/m/data',
                name: 'm.data',
                meta: {
                    keepAlive: true,
                    navActive: 0
                },
                component: Data
            },
            {    /*提交交易*/
                path: '/m/transaction/:id',
                name: 'm.transaction',
                component: Transaction
            },
            {    /*支付页面*/
                path: '/m/payment/:id',
                name: 'm.payment',
                component: Payment
            },
            {    /*支付结果页面*/
                path: '/m/result/:orderId',
                name: 'm.result',
                component: PayResult
            },
            {    /*待付款*/
                path: '/m/pendingpayment/:status',
                name: 'm.pendingpayment',
                meta: {
                    title: '我的订单',
                    auth: true,
                    navActive: 4 // - 1
                },
                component: Ppay
            },
            {    /*快递包裹*/
                path: '/m/expresses/:status',
                name: 'm.expresses',
                meta: {
                    title: '我的快递',
                    auth: true,
                    keepAlive: true,
                    navActive: 2
                },
                component: exp
            },
            {    /*查询运单结果*/
                path: '/m/tail/:expId',
                name: 'm.tail',
                component: Tail
            },
            {    /*登录*/
                path: '/m/login',
                name: 'm.login',
                component: Login
            },
            {    /*注册*/
                path: '/m/register',
                name: 'm.register',
                component: Register
            },
            {    /*门店绑定*/
                path: '/m/shopBind/:id',
                name: 'm.shopBind',
                component: ShopBind
            }
        ]
    },
]
